import { getSessionId } from "@redux/memoizedSelectors";
import { handleAddRenderElement } from "@utils/helpers";
import { getterApis } from "@utils/optionsSets/getterApis";
import Export from "features/analytics/Components/Export";
import FiltersManager from "features/analytics/Components/Filters/FiltersManager";
import HorizontalBarsChart from "features/analytics/Components/HorizontalBarsChart";
import Section from "features/analytics/Components/Section";
import { AnalyticsLogoHeader, Body, BodySection, DashboardContainer, TopSection } from "features/analytics/Style";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import FinancialImpactPerMeasure from "./Reports/FinancialImpactPerMeasure";
import KpiByActual from "./Reports/KpiByActual";
import { countMeasuresSelector, ownerByFinancialImpactSelector, roiPerProject } from "./roiAnalysisDataSelectors";
import { applyFilterRoiAnalysis } from "features/analytics/reducer/ROIAnalysis/roiAnalysisActions";
import React from "react";

function ROIAnalysisReports() {
	const { t } = useTranslation();
	const pdfRef = React.useRef();

	const filterBy = useSelector((state) => state.analytics?.roiAnalysis?.selectedFilterOptions?.filterBy);
	const hideForPdf = useLocation().search.hideForPdf();
	const sessionId = useSelector(getSessionId);
	const logoRefreshValue = useSelector((state) => state.settings.organization?.logoRefreshValue);

	const logoUrl = getterApis["GET_ACCOUNT_IMG"](sessionId, logoRefreshValue);

	const getFiltersToSave = ({ currentEntityData }) => {
		return {
			filterBy: currentEntityData?.selectedFilterOptions?.filterBy,
			cjms: currentEntityData?.selectedFilterOptions?.cjms.map((cjm) => cjm?.id),
			projects: currentEntityData?.selectedFilterOptions?.projects.map((p) => p?.id),
			startDate: currentEntityData?.selectedFilterOptions?.date?.startDate,
			endDate: currentEntityData?.selectedFilterOptions?.date?.endDate,
		};
	};

	const getFilterEntities = () => {
		if (filterBy === "cjms") return ["filterBy", "cjms"];
		return ["filterBy", "projects", "dateRange"];
	};

	return (
		<DashboardContainer>
			{hideForPdf && <AnalyticsLogoHeader src={logoUrl} alt="logo" loading="lazy" />}
			<TopSection>
				<FiltersManager filterEntities={getFilterEntities()} applyAction={applyFilterRoiAnalysis} dashboardName="roiAnalysis" />
				<Export dashboardName="roianalysis" fileName={t("ROI_ANALYSIS")} getFiltersToSave={getFiltersToSave} pdfRef={pdfRef} />
			</TopSection>
			<BodySection ispdf={hideForPdf}>
				<Body ref={pdfRef}>
					<Section>
						<KpiByActual title={t("KPI_ACTUAL_ACHIEVEMENT")} />
					</Section>

					<Section>
						<FinancialImpactPerMeasure title={t("FINACICAL_IMPACT_MEASURE")} background="linear-gradient(178deg, #F0F9FF 1.32%, #FFF 62.25%)" />
					</Section>
					<Section>
						<HorizontalBarsChart
							title={t("TOP_FIVE") + " " + t("MEASURES")}
							dataSelector={countMeasuresSelector}
							barColor="#5EEAD4"
							relatedItemsTitle={t("ASPX_97")}
							emptyDataText="TOP_MEASURES_REPORT_DESCRIPTION"
						/>
						<HorizontalBarsChart
							title={t("FINACICAL_IMPACT_PROJECT")}
							dataSelector={roiPerProject}
							barColor="#93C5FD"
							relatedItemsTitle={t("ASPX_97")}
							emptyDataText="ROI_BY_PROJECT_REPORT_DESCRIPTION"
						/>
						<HorizontalBarsChart
							title={t("FINACICAL_IMPACT_PROJECT_OWNER")}
							dataSelector={ownerByFinancialImpactSelector}
							barColor="#D8B4FE"
							relatedItemsTitle={t("ASPX_97")}
							emptyDataText="REVENUE_BY_PROJECT_REPORT_DESCRIPTION"
						/>
					</Section>
				</Body>
			</BodySection>
			{hideForPdf && <div id="addRenderElement">{handleAddRenderElement(3000)} </div>}
		</DashboardContainer>
	);
}

ROIAnalysisReports.displayName = "ROIAnalysisReports";
export default ROIAnalysisReports;
